import api, { unwrap } from './client';

export async function listAuditLogs(params = {}) {
  return unwrap(await api.get('/admin/audit-logs', { params }));
}

export async function listAuditActions(params = {}) {
  return unwrap(await api.get('/admin/audit-logs/actions', { params }));
}
